// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-dialog__UQz_v {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.error-dialog--title__sUQIE {
  margin-bottom: 48px;
}
.error-dialog--button__xKns4 {
  width: 406px;
}
.error-dialog--button--primary__FRRqZ {
  margin-top: 56px;
}
.error-dialog--button--secondary__pl9mL {
  margin-top: 32px;
}

.network-error-dialog--fade-wrapper__iaMrx {
  opacity: 1;
  transition: opacity 200ms ease-in-out;
}
.network-error-dialog--fade-wrapper-fade-out__iBqWG {
  opacity: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/error-dialog/error-dialog.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AACF;AACE;EACE,mBAAA;AACJ;AAEE;EACE,YAAA;AAAJ;AAEI;EACE,gBAAA;AAAN;AAGI;EACE,gBAAA;AADN;;AAQE;EACE,UAAA;EACA,qCAAA;AALJ;AAQE;EACE,UAAA;AANJ","sourcesContent":[".error-dialog {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n\n  &--title {\n    margin-bottom: 48px;\n  }\n\n  &--button {\n    width: 406px;\n\n    &--primary {\n      margin-top: 56px;\n    }\n\n    &--secondary {\n      margin-top: 32px;\n    }\n  }\n}\n\n// Network Error Dialog styles\n.network-error-dialog {\n  &--fade-wrapper {\n    opacity: 1;\n    transition: opacity 200ms ease-in-out;\n  }\n\n  &--fade-wrapper-fade-out {\n    opacity: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"error-dialog": `error-dialog__UQz_v`,
	"error-dialog--title": `error-dialog--title__sUQIE`,
	"error-dialog--button": `error-dialog--button__xKns4`,
	"error-dialog--button--primary": `error-dialog--button--primary__FRRqZ`,
	"error-dialog--button--secondary": `error-dialog--button--secondary__pl9mL`,
	"network-error-dialog--fade-wrapper": `network-error-dialog--fade-wrapper__iaMrx`,
	"network-error-dialog--fade-wrapper-fade-out": `network-error-dialog--fade-wrapper-fade-out__iBqWG`
};
export default ___CSS_LOADER_EXPORT___;
